export default __webpack_public_path__ + "static/media/lj1.02f2854c.png";